import machineIcon from '../../../assets/image/inputGroups/machinery.svg';
import {IOrderItem} from '../../../services/hookService/getOrderDetails/types';
import PriceWithDiscount from '../components/PriceWithDiscount';
interface OrderItemProps {
  order: IOrderItem;
}

const OrderItem = ({order}: OrderItemProps) => {
  return (
    <div className="relative flex items-center gap-3 px-4 pt-2 pb-4">
      <div className="relative flex items-start justify-start w-fit shrink-0">
        <img
          src={order.image ?? order.sub_brand_image ?? machineIcon}
          alt="item-icon"
          className="w-14 h-14"
        />

        <span className="bg-white text-gray-800 px-[5px] py-[2px] rounded-lg text-sm font-medium absolute -top-1 -left-1">
          {order.quantity}
        </span>
      </div>

      <div className="flex flex-col gap-4 mt-6">
        <span className="font-medium text-md line-clamp-1">
          {order.title_snapshot}
        </span>

        <div className="flex items-center gap-2 font-medium text-gray-800">
          <PriceWithDiscount
            className="col-span-2"
            originalPrice={order?.price_snapshot * order?.quantity}
            discountPrice={order?.discount_price}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderItem;
